import axios, { AxiosResponse } from 'axios'

import { AccountingReportRead } from '@generated/types'

const BASE_URL = '/api/accounting'

export default {
  async getSummary(
    month: string,
    type: 'accrual' | 'cash',
  ): Promise<AxiosResponse<AccountingReportRead[]>> {
    return axios.get(`${BASE_URL}/${type}/?months=${month}`)
  },
}
